import { createApp } from "vue/dist/vue.esm-bundler.js"
import { useVuelidate } from "@vuelidate/core";
import { required, email, helpers } from "@vuelidate/validators";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import recaptcha from '../components/recaptcha';

createApp({
    setup() {

        const params = new URLSearchParams(window.location.search);
        const selectedBerth = params.get('selectedBerth');

        return { v$: useVuelidate(), selectedBerth }
    },
    components: {
        VueDatePicker,
        recaptcha
    },
    computed: {
        submitEnabled() {
            return this.recaptchaPassed;
        }
    },
    data() {
        return {
            currentPage: 1,
            recaptchaPassed: false,
            page1: {
                desiredBerth: this.selectedBerth,
                vessel: '',
                voyageNumber: '',
                vesselOwner: '',
                loa: '',
                vesselCharterer: '',
                vesselDraft: '',
                agencyFirm: '',
                eta: null,
                authorizedIndividual: '',
                etd: null
            },
            page2: {
                category: null
            },
            page3: {
                name: '',
                email: '',
                phone: ''
            },
            pageProgress: 1
        }
    },
    methods: {
        async validatePage(page) {
            var isValid = false;

            if (page == 1) {
                isValid = await this.v$.page1.$validate();
            }
            else if (page == 2) {
                isValid = await this.v$.page2.$validate();
            }
            else if (page == 3) {
                isValid = await this.v$.page3.$validate();
            }
            else if (page == 4) {
                isValid = true;
            }
            
            return isValid;
        },
        async goToPage(page) {
            var isValid = await this.validatePage(this.currentPage);

            if (isValid) {

                if (page === 3) {
                    //var etaElement = document.getElementById("Eta");
                    //var etdElement = document.getElementById("Etd");
                    //Get 1 day in milliseconds
                    var one_day_ms = 1000 * 60 * 60 * 24;

                    var eta_date = new Date(this.page1.eta);
                    var etd_date = new Date(this.page1.etd);

                    // if the eta and etd days are same, charge for a whole day.
                    if (eta_date.getDay() === etd_date.getDay()) {
                        return 1;
                    }

                    // Convert both dates to milliseconds
                    var eta_ms = eta_date.getTime();
                    var etd_ms = etd_date.getTime();
                    // If etd is less than eta (which is invalid), return 0
                    if ((etd_ms - eta_ms) < 0) {
                        return 0;
                    }
                    // Calculate the difference in milliseconds
                    // Convert back to days and return
                    var leaseDays = Math.round((etd_ms - eta_ms) / one_day_ms);

                    var loa = parseFloat(this.page1.loa);

                    var rate = null;

                    for (var i = 0; i < dockageRates.length; i++) {
                        var value = dockageRates[i];

                        if ((value.Over == null || loa >= value.Over) && loa <= value.ButNotOver) {
                            rate = value;
                            break;
                        }

                        continue;
                    }

                    var securityFee = (leaseDays * perDayRate);

                    var layberth = (leaseDays * rate.Lay);
                    var regular = (leaseDays * rate.Regular);

                    $("#layberth-cost").text(layberth.toFixed(2) + " (25% of Regular ($" + regular.toFixed(2) + "))");
                    $("#vessel-security-fee").text(securityFee.toFixed(2) + " (number of days * $" + perDayRate + ")");
                    $("#mfsa-fee").text(mfsa.toFixed(2) + " (one time fee)");
                    $("#total-est-charge").text((layberth + mfsa + securityFee).toFixed(2));
                }

                this.currentPage = page;
                if (this.pageProgress < page) {
                    this.pageProgress = page;
                }
            }
        },
        async submit() {
            var isValid = await this.v$.$validate();

            if (isValid) {
                $('#layberth-request-form').submit();
            }
        },
        recaptchaCallback(newState) {
            this.recaptchaPassed = !!newState;
        }

    },
    validations() {
        return {
            page1: {
                desiredBerth: { required },
                vessel: { required },
                vesselOwner: { required },
                loa: { required },
                vesselCharterer: { required },
                vesselDraft: { required },
                agencyFirm: { required },
                eta: { required },
                authorizedIndividual: { required },
                etd: {
                    required,
                    isAfterStart: helpers.withMessage("ETD must be after ETA", (value) => {
                        if (!this.page1.etd || !value) return true;

                        return new Date(value) > new Date(this.page1.eta);
                    })
                }
            },
            page2: {
                category: { required }
            },
            page3: {
                name: { required },
                email: { required, email },
                phone: { required }
            },
        }
    }
}).mount('#layberthRequestFormApp');
